import React from 'react'
import { Button, Card, CardContent, Chip, Stack, Typography } from '@mui/material'
import { isEmptyString } from '../../../../utils/string-utils'
import TwoStepButton from '../../../../components/button/two-step-button'
import { inferExchangeSymbol } from '../../../../utils/exchange-utils'

interface GatewayConnectionStreamProps {
  identifier: string
  connection: {
    id: number
    uri: string
    params: string
  }
  reconnectCallback: () => void
}

const GatewayConnectionStream: React.FC<GatewayConnectionStreamProps> = ({ identifier, connection, reconnectCallback }) => {
  const { id, uri, params } = connection

  const symbol = inferExchangeSymbol(identifier, params, uri)

  return (
    <Card variant='outlined'>
      <CardContent>
        <Stack gap={1} padding={1}>
          <Stack direction='row' gap={1} justifyContent='space-between'>
            <Typography>{symbol}</Typography>
            <Chip size='small' variant='outlined' color='success' label={`ID: ${id}`}/>
          </Stack>
          <Stack direction='row' gap={1} sx={{ wordBreak: 'break-word' }}>
            <Typography>{uri}</Typography>
          </Stack>
          {
            !isEmptyString(symbol)
              ? <TwoStepButton action={reconnectCallback} firstText='Reconnect' secondText='Confirm Reconnect?'/>
              : <Button variant='outlined' disabled={true}>Use Manual Reconnect</Button>
          }
        </Stack>
      </CardContent>
    </Card>
  )
}

export default React.memo(GatewayConnectionStream)
